<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 625 625"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <g>
      <path
        d="M555.677,311.13c-0,-39.28 -31.843,-71.122 -71.123,-71.122c-91.484,-0 -249.461,-0 -340.946,-0c-39.28,-0 -71.122,31.842 -71.122,71.122c-0,69.151 -0,173.597 -0,242.748c-0,39.279 31.842,71.122 71.122,71.122c91.485,0 249.462,0 340.946,0c39.28,-0 71.123,-31.843 71.123,-71.122c-0,-69.151 -0,-173.597 -0,-242.748Zm-266.422,140.545c-0.002,-1.425 -0.754,-2.745 -1.98,-3.473c-13.944,-8.504 -23.253,-23.863 -23.253,-41.378c0,-26.756 21.722,-48.478 48.478,-48.478c26.756,-0 48.478,21.722 48.478,48.478c-0,17.515 -9.309,32.874 -23.245,41.392c-1.22,0.726 -1.968,2.04 -1.967,3.459c-0.021,10.796 -0.021,55.785 -0.021,55.785c0,5.74 -2.417,11.215 -6.659,15.082c-0.906,0.826 -1.861,1.696 -2.836,2.586c-7.791,7.102 -19.709,7.102 -27.5,-0c-0.975,-0.89 -1.93,-1.76 -2.836,-2.586c-4.242,-3.867 -6.659,-9.342 -6.659,-15.082l-0,-55.785Z"
      />
      <path
        d="M314.081,0c91.011,0 164.901,77.235 164.901,154.018l-0,51.217c-0,2.641 -1.049,5.174 -2.917,7.042c-1.867,1.867 -4.4,2.917 -7.041,2.917c-12.202,-0 -28.228,-0 -49.678,-0c-2.648,-0.001 -5.186,-1.055 -7.055,-2.931c-1.868,-1.875 -2.913,-4.418 -2.903,-7.065c0.606,-37.608 -1.005,-133.114 -96.888,-133.114c-93.761,-0 -96.292,98.58 -95.587,133.097c0.014,2.649 -1.028,5.194 -2.896,7.073c-1.868,1.878 -4.408,2.934 -7.057,2.934c-21.905,0.006 -32.658,0.006 -47.821,0.006c-5.5,-0 -9.959,-4.459 -9.959,-9.959c0,-16.058 0,-42.438 0,-51.217c0,-76.783 73.89,-154.018 164.901,-154.018Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconLocked"
};
</script>
